import {styled} from '@mui/material/styles';

import Icon from '../../components/Icon/IconSvg'

import { useState } from 'react';

import User from './User'

// import Promotion from '../Promotion'
// import Pos from '../Pos'

import Node from './Node'
import Stairs from './Stair'
import Swap from './Swap'
import Merchant from './Merchant'

const size = 26
const iconStyle = {
    width: size,
    height: size,
    // fill: '#6b6d77',
    fill: '#fff',
    opacity: 0.2
}

const iconActivedStyle = {
    width: size,
    height: size,
    fill: '#fff'
}

function ActivedPools({i , actived, children, ...props}) {
    const st = actived ? iconActivedStyle : iconStyle
    return (
        <IconWrap {...props}>
            <Icon i={i} {...st} style={{width: '32px', height: '32px'}}/>
            {children}
        </IconWrap>
    )
}

// stakeholder,
// stair

let tabList = {
    home: Node,
    share: Merchant,
    // stair: Stairs,
    // swap: Swap,
    user: User,
}
// const StartTime = new Date('2026-09-21 20:00:00').getTime() 
// if ( new Date().getTime() >= StartTime ) {
//     tabList = {
//         home: Node,
//         share: Merchant,
//         stair: Stairs,
//         swap: Swap,
//         user: User,
//     }
// }
const tabArray = Object.keys(tabList)
let _table = tabArray[0]
function Foot() {
    const [tab, setTab] = useState(_table)
    const Page = tabList[tab]
    //  useMemo(() => {
    //     console.log(tab)
    //     return tabList[tab]
    // }, tab)
    // console.log(tab, "12---3123")

    return (
        <>  
            <Page />
            <FootWraper>
                <FootFild>
                    {
                        tabArray.map(k => 
                            <ActivedPools
                                i={k}
                                key={k}
                                actived={k === _table}
                                onClick={() => {
                                    setTab(k)
                                    _table = k
                                }}
                            />
                        )
                    }
                </FootFild>
            </FootWraper>
        </>
        
    )
}

export default Foot

const FootWraper = styled('div')`
    width: 100%;
    position: relative;
    height: ${p => p.h || '65px'};
    margin-top: 20px;
`

const FootFild = styled('div')`
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #17181f;
    height: inherit;
    border-radius: 14px 14px 0 0;
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
    box-shadow: 0px -4px 15px #00000073;
    z-index: 2;
`

const IconWrap = styled('div')`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const LogoWrap = styled('div')`
    display: flex;
    justify-content: center;
    align-items: center;
    background: #1e2026;
    padding: 14px;
    width: 120px;
    border-radius: 100%;
    height: 68px;
    margin-top: -22px;
    box-shadow: 0px 6px 8px #1f2025;
`